module.exports = __webpack_public_path__ + "static/media/pic2.1f3404a5.jpg";